declare var $;

interface CloseDetailsScope extends ng.IScope {
  hideDetails(): any;
}

export default function CloseDetailsDirective($document) {
  'ngInject';

  return {
    link: function ($scope: CloseDetailsScope) {
      // You'd be forgiven for thinking you could use $window here, but IE doesn't support the click event on the
      // window.
      $document.bind('click', (event) => {
        // This rule is rather complicated but I have to test to see if they clicked exactly on a puck or the details
        // or any children of either one.
        //
        // A recent addition was the pricing graph modal. Since that can be brought up while viewing the details,
        // clicking anywhere in the modal should also not hide the details.
        // And I've had to add the spans which hold the dropdown arrows because, for some bizarre reason, when they
        // are listed as the target of a click, they have no parent?!? So the test for the parent being the details
        // fails.
        var target = $(event.target);
        if (
          !(
            target.hasClass('puck') ||
            target.hasClass('details') ||
            target.hasClass('pricingGraphModal') ||
            target.hasClass('modal') ||
            target.hasClass('ss-icon') ||
            target.parents('.puck, .details, .pricingGraphModal').length > 0 ||
            target.parents('.puck, .details, .modal').length > 0
          )
        ) {
          // Since the binding is done via jQuery, we have to call this so AngularJS will perform a digest cycle.
          $scope.$apply(() => $scope.hideDetails());
        }
      });

      $document.bind('keyup', (event) => {
        if (event.keyCode === 27) {
          $scope.$apply(() => $scope.hideDetails());
        }
      });
    }
  };
}
